import { Component, Vue } from 'vue-property-decorator';
import store from "Store/index";


@Component
export default class UserMixin extends Vue 
{
   public async created() {
       await store.dispatch.auth.loadUser();
   }
}
